import React, { createContext, useContext, useState, useRef } from "react";

const SearchContext = createContext(null);

export const SearchProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchType, setSearchType] = useState("productName");
  const [selectedArtist, setSelectedArtist] = useState(0);
  const triggerSearchRef = useRef(null);

  return (
    <SearchContext.Provider
      value={{
        searchQuery,
        setSearchQuery,
        searchType,
        setSearchType,
        selectedArtist,
        setSelectedArtist,
        triggerSearchRef,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  const ctx = useContext(SearchContext);
  if (!ctx) throw new Error("useSearch must be used within SearchProvider");
  return ctx;
};

export default SearchContext;
